import _ from 'lodash';
import VariationAccessor from './VariationAccessor';
import resolveNumericFactor from '../resolvers/NumericFactorResolver';
import resolveColor from '../resolvers/ColorResolver';
var ThemeAccessor = /** @class */ (function () {
    // ToDo: Update this property using
    // https://github.com/expo/match-media
    // https://github.com/contra/react-responsive
    // ToDo: react-responsive has no option to just get device width
    // ToDo: for that reason we implement it on our own, using https://www.npmjs.com/package/matchmediaquery which is used in react-responsive internally
    // private appWidth: number;
    function ThemeAccessor(theme) {
        this.designGrid = theme.designGrid;
        this.colorScheme = theme.colorScheme;
        this.typography = theme.typography;
        this.coreThemes = this.toVariationAccessorCollection(theme.coreThemes);
        this.containerThemes = this.toVariationAccessorCollection(theme.containerThemes);
        this.advancedControlsThemes = this.toVariationAccessorCollection(theme.advancedControlsThemes);
        this.layoutThemes = this.toVariationAccessorCollection(theme.layoutThemes);
        this.pluginThemes = theme.pluginThemes;
        this.themeAccessor = this;
    }
    ThemeAccessor.prototype.resolveFactor = function (factor) {
        var activeFactor = this.resolveResponsiveValue(factor);
        return activeFactor === null || activeFactor === void 0 ? void 0 : activeFactor.toString();
    };
    ThemeAccessor.prototype.resolveNumericFactor = function (numericFactor) {
        var activeFactor = resolveNumericFactor(this, 0, numericFactor);
        return activeFactor;
    };
    ThemeAccessor.prototype.resolveColor = function (color) {
        var activeColor = resolveColor(this, 0, color);
        return activeColor;
    };
    //#region internal methods
    ThemeAccessor.prototype.toVariationAccessorCollection = function (themeCollection) {
        var variationAccessorCollection = {};
        for (var themeName in themeCollection) {
            var variationAccessor = new VariationAccessor(this, themeCollection[themeName]);
            variationAccessorCollection[themeName] = variationAccessor;
        }
        return variationAccessorCollection;
    };
    // ToDo: create a cache here, where we cache all min-max values
    // using this information, we should be able to just re-calculate when there is really a change
    // ToDo: Maybe add an api, which can be called by ReactBaseProvider, when the user switches the screen, to clear the cache!
    ThemeAccessor.prototype.resolveResponsiveValue = function (responsiveValue) {
        if (_.isArray(responsiveValue)) {
            // ToDo: implement responsive support using appWidth
            throw new Error("Responsive support is in development");
        }
        return responsiveValue;
    };
    return ThemeAccessor;
}());
export default ThemeAccessor;
//# sourceMappingURL=ThemeAccessor.js.map